import React from 'react';
import { useState, useContext, useEffect } from "react";
import '../../assets/core.css';
import logo from '../../assets/images/logoNovo.png';
import config from '../../assets/images/config.png';
import { Link, useNavigate } from "react-router-dom";
// import { AuthContext } from '../../contexts/AuthContext';

function Menu() {

    const navigate = useNavigate();
    function Logout() {
        localStorage.clear();
        navigate('/login');
    }

    // const {  nomeEmpresa,nomeUsuario, emailUsuario, setNomeEmpresa,setEmpresas, setNomeUsuario, setEmailUsuario } = useContext(AuthContext);


    useEffect(() => {

    }, []);


    return <>
        <div className="main-wrapper"></div>
        <nav className="sidebar">
            <div className="sidebar-header">
                <a href="#" className="sidebar-brand">
                    <span className="img-container">
                        <img src={logo} width={100} height={30} />
                    </span>
                </a>
                <div className="sidebar-toggler not-active">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className="sidebar-body">
                <ul className="nav">
                    <li className="nav-item nav-category">Menu</li>

                    <li className="nav-item">
                        <Link to="/dashboard" className="nav-link">
                            <i className="link-icon" data-feather="box"></i>
                            <span className="link-title">Dashboard</span>
                        </Link>

                    </li>
                    <li className="nav-item nav-category">Portal</li>
                    <li className="nav-item">
                        <a className="nav-link" data-bs-toggle="collapse" href="#portal" role="button" aria-expanded="false" aria-controls="portal">
                            <i className="link-icon" data-feather="mail"></i>
                            <span className="link-title">Documentos fiscais</span>
                            <i className="link-arrow" data-feather="chevron-down"></i>
                        </a>
                        <div className="collapse" id="portal">
                            <ul className="nav sub-menu">
                                <li className="nav-item">
                                    <Link to="/nfeentrada" className="nav-link">NF-e  Entradas</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/nfesaida" className="nav-link">NF-e  Saídas</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cte" className="nav-link">CT-e</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/nfce" className="nav-link">NFC-e</Link>
                                </li>
                                {/* <li className="nav-item">
                                    <Link to="/nfse" className="nav-link">NFSe (Serviço)</Link>
                                </li> */}
                                <li className="nav-item">
                                    <Link to="/fechamento" className="nav-link">Fechamento</Link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    {/* <li className="nav-item">
                        <a className="nav-link" data-bs-toggle="collapse" href="#relatoriosPortal" role="button" aria-expanded="false" aria-controls="relatoriosPortal">
                            <i className="link-icon" data-feather="inbox"></i>
                            <span className="link-title">Relatórios</span>
                            <i className="link-arrow" data-feather="chevron-down"></i>
                        </a>
                        <div className="collapse" id="relatoriosPortal">
                            <ul className="nav sub-menu">
                                <li className="nav-item">
                                    <a href="pages/forms/basic-elements.html" className="nav-link">Relação de doctos por data</a>
                                </li>
                            </ul>
                        </div>
                    </li> */}

                    {/* <li className="nav-item nav-category">Faturamento</li>
                    <li className="nav-item">
                        <a className="nav-link" data-bs-toggle="collapse" href="#cadastros" role="button" aria-expanded="false" aria-controls="cadastros">
                            <i className="link-icon" data-feather="anchor"></i>
                            <span className="link-title">Cadastros</span>
                            <i className="link-arrow" data-feather="chevron-down"></i>
                        </a>
                        <div className="collapse" id="cadastros">
                            <ul className="nav sub-menu">
                                <li className="nav-item">
                                    <Link to="/cliente" className="nav-link">Clientes</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/fornecedor" className="nav-link">Fornecedores</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/transportadora" className="nav-link">Transportadoras</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/produto" className="nav-link">Produtos</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/ncm" className="nav-link">NCM</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/cfop" className="nav-link">Natureza (CFOP)</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/artigo" className="nav-link">Obs. Automática</Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/faturamentomensal" className="nav-link">Faturamento mensal</Link>
                                </li>
                            </ul>
                        </div>
                        <li className="nav-item">
                            <a href="pages/apps/chat.html" className="nav-link">
                                <i className="link-icon" data-feather="message-square"></i>
                                <span className="link-title">Nota Fiscal</span>
                            </a>
                        </li>


                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="collapse" href="#relatoriosFat" role="button" aria-expanded="false" aria-controls="relatoriosFat">
                                <i className="link-icon" data-feather="inbox"></i>
                                <span className="link-title">Relatórios</span>
                                <i className="link-arrow" data-feather="chevron-down"></i>
                            </a>
                            <div className="collapse" id="relatoriosFat">
                                <ul className="nav sub-menu">
                                    <li className="nav-item">
                                        <a href="pages/forms/basic-elements.html" className="nav-link">Relação de NFe por data</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </li> */}

                </ul>
            </div>
           <div className="sidebar-footer flex-column flex-md-row px-4 py-3">
              {/* d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small"> */}
                <p className="text-muted mb-1 mb-md-0">Copyright © 2026 - v1.21</p>
                <p className="text-muted">Kiron Sistemas</p>

            </div>

        </nav>

        <div className="page-wrapper">
            <nav className="navbar">
                <a href="#" className="sidebar-toggler">
                    <i data-feather="menu"></i>
                </a>
                <div className="navbar-content">

                    <ul className="navbar-nav">
                        {/* <li className="nav-item dropdown">
                            <select className="form-select" name="empresa_select" id="selectEmpresa" onChange={ChangeEmpresa}>
                                {
                                    empresas.map((item) => {
                                        return <option key={item.id} value={item.idEntidade}>{item.nome}</option>
                                    })
                                }
                            </select>

                        </li> */}
                        <li li className="nav-item label">
                            <h4>{localStorage.getItem('nomeEmpresa')}</h4>

                        </li>

                        {/* Espaço */}
                        <li li className="nav-item label">
                        </li>

                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="notificationDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i data-feather="bell"></i>
                                <div className="indicator">
                                    <div className="circle"></div>
                                </div>
                            </a>
                            <div className="dropdown-menu p-0" aria-labelledby="notificationDropdown">
                                <div className="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                                    <p>6 New Notifications</p>
                                    <a href="javascript:;" className="text-muted">Clear all</a>
                                </div>
                                <div className="p-1">
                                    <a href="javascript:;" className="dropdown-item d-flex align-items-center py-2">
                                        <div className="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                                            <i className="icon-sm text-white" data-feather="gift"></i>
                                        </div>
                                        <div className="flex-grow-1 me-2">
                                            <p>New Order Recieved</p>
                                            <p className="tx-12 text-muted">30 min ago</p>
                                        </div>
                                    </a>
                                    <a href="javascript:;" className="dropdown-item d-flex align-items-center py-2">
                                        <div className="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                                            <i className="icon-sm text-white" data-feather="alert-circle"></i>
                                        </div>
                                        <div className="flex-grow-1 me-2">
                                            <p>Server Limit Reached!</p>
                                            <p className="tx-12 text-muted">1 hrs ago</p>
                                        </div>
                                    </a>
                                    <a href="javascript:;" className="dropdown-item d-flex align-items-center py-2">
                                        <div className="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                                            <img className="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="userr" />
                                        </div>
                                        <div className="flex-grow-1 me-2">
                                            <p>New customer registered</p>
                                            <p className="tx-12 text-muted">2 sec ago</p>
                                        </div>
                                    </a>
                                    <a href="javascript:;" className="dropdown-item d-flex align-items-center py-2">
                                        <div className="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                                            <i className="icon-sm text-white" data-feather="layers"></i>
                                        </div>
                                        <div className="flex-grow-1 me-2">
                                            <p>Apps are ready for update</p>
                                            <p className="tx-12 text-muted">5 hrs ago</p>
                                        </div>
                                    </a>
                                    <a href="javascript:;" className="dropdown-item d-flex align-items-center py-2">
                                        <div className="wd-30 ht-30 d-flex align-items-center justify-content-center bg-primary rounded-circle me-3">
                                            <i className="icon-sm text-white" data-feather="download"></i>
                                        </div>
                                        <div className="flex-grow-1 me-2">
                                            <p>Download completed</p>
                                            <p className="tx-12 text-muted">6 hrs ago</p>
                                        </div>
                                    </a>
                                </div>
                                <div className="px-3 py-2 d-flex align-items-center justify-content-center border-top">
                                    <a href="javascript:;">View all</a>
                                </div>
                            </div>
                        </li>
                         */}
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="profileDropdown" role="button" data-bs-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                                {/* <img className="wd-30 ht-30 rounded-circle" src="https://via.placeholder.com/30x30" alt="profile" /> */}
                                <img className="wd-20 ht-20 rounded-circle" src={config} alt="Configurações" />
                            </a>
                            <div className="dropdown-menu p-0" aria-labelledby="profileDropdown">
                                <div className="d-flex flex-column align-items-center border-bottom px-5 py-3">
                                    <div className="mb-3">
                                        {/* <img className="wd-80 ht-80 rounded-circle" src="https://via.placeholder.com/80x80" alt="" /> */}
                                        {/* <img className="wd-60 ht-60 rounded-circle" src={config} alt="" /> */}
                                        <p className="tx-14 text-muted">Configurações do Sistema</p>
                                    </div>
                                    <div className="text-center">
                                        <p className="tx-14 fw-bolder">{localStorage.getItem('nomeUsuario')}</p>
                                        <p className="tx-12 text-muted">{localStorage.getItem('emailUsuario')}</p>
                                    </div>
                                </div>
                                <ul className="list-unstyled p-1">
                                    <li className="dropdown-item py-2">
                                        <Link to="/trocar" className="nav-link">Trocar Empresa</Link>
                                    </li>
                                    <li className="dropdown-item py-2">
                                        <Link to="/empresa" className="nav-link">Minha Empresa</Link>
                                    </li>
                                    <li className="dropdown-item py-2">
                                        <Link to="/certificado" className="nav-link">Certificado digital</Link>
                                    </li>

                                    <li className="dropdown-item py-2">
                                        <Link to="/usuario" className="nav-link">Usuários</Link>
                                    </li>
                                    <li className="nav-item">
                                        <a onClick={Logout} href="/" className="nav-link">
                                            Sair
                                        </a>
                                    </li>

                                    {/* 
                                    <li className="dropdown-item py-2">
                                    <NavLink onClick={() => Logout()}  className="nav-link">Log Out</NavLink>                                    
                                    </li> */}
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <footer
                className="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
                <p className="text-muted mb-1 mb-md-0">Copyright © 2023 <a href="https://www.kiron.net.br"
                    target="_blank">Kiron</a>.</p>
                <p className="text-muted">Kiron Sistemas</p>
            </footer>


        </div>
    </>
}

export default Menu;
